import NoChangeAspectType from './size-style-type';

/**
 * 属性的key
 */
export const LOCK_KEY = 'size-adjust';

export const Locks = {
    LOCKS: 'locks',
    SP_LOCKS: 'spLocks',
    GRP_LOCKS: 'grpLocks',
    PIC_LOCKS: 'picLocks',
};
export const LocksAttributes = {
    NO_CHANGE_ASPECT: 'noChangeAspect',
};

export interface ILockProperty {
    /**
     * 获取锁定纵横比
     */
    getLockInfo(): ILocks | undefined;

    /**
     * 更新锁定纵横比属性
     */
    updateLocks(value: number): void;

    /**
     * 刷新 多选图形|组合 合并后的效果值
     * 多选图形、组合的属性是综合所有子元素而来的。基于性能考虑，加入缓存，只在必要时重新获取更新缓存
     */
    refreshMergePropertyValCache(): ILocks | undefined;
}

export interface ILocks {
    noChangeAspectType?: INoChangeAspectType;   // 锁定纵横比属性
}

// 锁定纵横比属性
export type INoChangeAspectType = typeof NoChangeAspectType[keyof typeof NoChangeAspectType];

export interface ILockProps {
    noChangeAspect: number;
}
